module.exports = __webpack_public_path__ + "static/media/no_image_ph.8be3efa1.png";